import { render } from "./PopUpAgendaShow.vue?vue&type=template&id=10ca4650"
import script from "./PopUpAgendaShow.vue?vue&type=script&lang=js"
export * from "./PopUpAgendaShow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__